import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../features/dialog';
import { enqueueErrorSnack, enqueueSuccessSnack } from '../../features/snackbar';
import axios from 'axios';
import { commonApiPromise } from '../../common';

const DIALOG_ID = "deleteGroup"
const DIALOG_WIDTH = "sm"

function DeleteGroupDialog({ onGroupDeleted }) {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const groupId = useSelector((state) => state.dialog[DIALOG_ID])
    const show = !!groupId;

    const groupLabel = Array.isArray(groupId) ? "selected groups" : `group ${groupId}`;

    const handleSubmit = e => {
        e && e.preventDefault() && e.stopPropagation();
        setLoading(true);
        
        commonApiPromise(axios.post("/netfeedr/group_delete", { groupId }), dispatch)
        .then(data => {
            if (data && !data.error) {
                dispatch(closeDialog(DIALOG_ID));
                dispatch(enqueueSuccessSnack("Group deleted successfully"));
                // Refresh the groups list
                if (onGroupDeleted) {
                    onGroupDeleted();
                }
            }
        })
        .catch(error => {
            // Error handling is done by commonApiPromise
        })
        .finally(() => {
            setLoading(false);
        });
    }

    const onClose = () => {
        dispatch(closeDialog(DIALOG_ID));
    }
    
    return <Dialog
        open={!!show}
        onClose={onClose}
        fullWidth
        maxWidth={DIALOG_WIDTH}
        
    >
        <form onSubmit={handleSubmit}>
            <DialogTitle>
                Delete Group
            </DialogTitle>
            <DialogContent dividers={false}>
                <Typography variant="subtitle1">
                    Are you sure you want to delete the <b>{groupLabel}</b>?
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    This will remove the group and unassign all channels from it. The channels themselves will not be deleted.
                </Typography>
            </DialogContent>
            <DialogActions>
                {loading && <LinearProgress />}
                {!loading && <Box sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Button sx={{marginRight: 2}} onClick={onClose} >Cancel</Button>
                    <Button variant="contained" color="error" type="submit">Delete</Button>
                </Box>}
            </DialogActions>
        </form>
    </Dialog>
}

export default DeleteGroupDialog;